<template>
  <div id="default-layout">
    <StatusBanner :variantPayload="bannerPayload" />
    <Sidebar v-if="signedIn()" />
    <Navbar v-if="signedIn()" />
    <div class="default-layout">
      <slot />
    </div>
  </div>
</template>

<script>
import store from '@/store';
import Sidebar from '@/components/Sidebar';
import Navbar from '@/components/Navbar';
import StatusBanner from '@/components/StatusBanner';
import { getUnleashVariant } from '@/lib/unleash';

export default {
  components: {
    Navbar,
    Sidebar,
    StatusBanner
  },
  data() {
    return {
      bannerPayload: null
    };
  },
  methods: {
    signedIn() {
      return store.state.user;
    }
  },
  async created() {
    try {
      const variant = getUnleashVariant('status-banner');
      if (variant?.payload?.value) {
        this.bannerPayload = JSON.parse(variant.payload.value);
      } else {
        console.log('[StatusBanner] No variant payload found');
      }
    } catch (err) {
      console.warn('Invalid Unleash banner payload:', err);
    }
  }
};
</script>

<style>
@media screen and (min-width: 992px) and (max-width: 1199px) {
  .mb-7.container {
    max-width: 885px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1439px) {
  .mb-7.container {
    max-width: 1085px;
  }
}
@media screen and (min-width: 1439px) and (max-width: 1550px) {
  .mb-7.container {
    max-width: 1330px;
  }
}
@media screen and (min-width: 62em) {
  .default-layout > .container {
    max-width: calc(100% - 8rem);
  }
}
</style>
